import React from 'react';
import styles from './PulsingCircle.module.scss';

const PulsingCircle = () => <div className={styles.circle} />;

export default PulsingCircle;
